"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Vue, Component } from "vue-property-decorator";
import { ModelBuilderUtil } from "@ym-framework/model";
import API from "@ym-framework/api-utils";
export class AccountSessionPlugin {
  static install(Vue2) {
    return __async(this, null, function* () {
      const _session = yield API.get(`api://base.local/storages/session/session`);
      if (_session.data.value) {
        Vue2.$session = _session.data.value.session;
      }
    });
  }
}
export class AccountSessionStorage {
  static getSession() {
    return this._session;
  }
  static setSession(session) {
    this._session = session;
  }
}
export let AccountSessionMixins = class extends Vue {
  get $session() {
    const _session = AccountSessionStorage.getSession();
    if (_session) {
      return ModelBuilderUtil.builder(_session);
    }
    return void 0;
  }
};
AccountSessionMixins = __decorateClass([
  Component
], AccountSessionMixins);
